import * as yup from "yup";

const registerCareersSchema = yup
  .object({
    name: yup
      .string()
      .required("Name is required")
      .matches(/^[A-Za-z\s]+$/, "Name must contain only letters and spaces"),

    email: yup
      .string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[cC][oO][mM]$/,
        "Email must end with .com"
      ),

    phone: yup.string().required("Phone number is required"),

    attachment: yup
      .mixed()
      .test("fileType", "Only PDF, DOC, DOCX files are allowed", (value) => {
        if (!value || value.length === 0) return true; // Optional field
        const file = value[0];
        if (!file) return true;
        const supportedFormats = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        return supportedFormats.includes(file.type);
      }),
  })
  .required();

export default registerCareersSchema;
